export const containerCodesOld = [
  {wording: 'Bouteille en verre', code: 'BO_GLASS'},
  {wording: 'Bouteille en plastique', code: 'BO_PLASTIC_OTHER'},
  {wording: 'BIB(Fontaine à vin) / Cubi', code: 'BBG'},
  {wording: 'Canette', code: 'CNG'},
  {wording: 'Autre', code: 'OTHERS'}
];
